import { logger } from '../../../utils/logger';

/**
 * This is similar to isExperimentEnabled utility function, but it is used for SSE experiments.
 *
 * @param instantConfig
 * @param {string} experimentTicket ticket number (e.g. aden-12345)
 * @param {string} experimentName
 * @param {string} logGroup
 *
 * @returns {string|false} return the variant name if the experiment is enabled, otherwise false
 */
export default function isExperimentEnabledSSE(
	instantConfig,
	experimentTicket,
	experimentName,
	logGroup,
) {
	const regex = new RegExp(`^sse-${experimentTicket}-(control|variant\\d)$`);

	const experimentClassName = Array.from(document.documentElement.classList).find((className) =>
		regex.test(className),
	);
	const experimentVariant = experimentClassName?.split('-').pop();

	if (experimentVariant && instantConfig.get('icExperiments', []).includes(experimentName)) {
		logger(logGroup, 'Experiment enabled');
		return experimentVariant;
	}

	logger(logGroup, 'Experiment disabled');
	return false;
}
